import {Injectable} from "@angular/core";
import {ApiClient} from "../../tools/api-client";
import {Observable} from "rxjs";
import {FoundMeasurement} from "./found-measurement";
import {map} from "rxjs/operators";

import {recursiveNullToUndefined} from "../../tools/recursive-null-to-undefined";

export interface CloseAnalysisRequest {
  measurementId: number;
  report: File | undefined;
}

@Injectable()
export class CloseAnalysisService {

  constructor(private readonly apiClient: ApiClient) {
  }

  closeAnalysis({measurementId, report}: CloseAnalysisRequest): Observable<FoundMeasurement> {
    return this.apiClient
      .put<FoundMeasurement>(
      `/api/measurements/${measurementId}/close-analysis`,
      report ? createMultipartRequest(report) : null
    )
      .pipe(map(listItem => recursiveNullToUndefined(listItem)));
  }
}

function createMultipartRequest(report: File): FormData {
  const formData = new FormData();
  formData.append("reportFile", report, report.name);
  return formData;
}
